import { render, staticRenderFns } from "./viewRecording.vue?vue&type=template&id=63ec4360&scoped=true"
import script from "./viewRecording.vue?vue&type=script&lang=js"
export * from "./viewRecording.vue?vue&type=script&lang=js"
import style0 from "./viewRecording.vue?vue&type=style&index=0&id=63ec4360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec4360",
  null
  
)

export default component.exports